import { baseServiceExportExcel } from './baseServiceExportExcel'
import { PAGE_SIZE } from '../data/queryFactories'

class ExportExcelBook extends baseServiceExportExcel {
  baseUrl = 'book/export'

  async export(payloads) {
    try {
      const payload = {
        pageSize: payloads?.pageSize ?? PAGE_SIZE,
        pageNumber: payloads?.pageNumbers ?? 0,
        keywords: payloads?.keywords,
        createdAt: payloads?.createdAt ?? undefined,
        bookCollectionUuid: payloads?.book_collection_uuid ?? undefined,
      }

      const res = await this.post(this.baseUrl, payload)
      return res
    } catch (error) {
      console.error('ExportExcelBook.export error:', error)
      throw error
    }
  }
}

export const exportExcelBook = new ExportExcelBook()
